import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/people/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/tasks/people/$id', params });
  },
});
